import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import Reveal from './Reveal.jsx';

const Section = styled.div`
  position: relative;
  padding: 70px 100px;
  border-top: 2px solid ${theme.border};
  display: flex;
  gap: 70px;
  @media (max-width: 900px) {
    flex-direction: column;
    padding: 50px 24px;
    gap: 30px;
  }
`;
const Col = styled.div`
  flex: 1;
  position: relative;
  z-index: 1;
`;
const Label = styled.div`
  font-family: ${theme.fontMono};
  font-size: 13px;
  letter-spacing: 0.08em;
  color: ${theme.accent};
  text-transform: uppercase;
  margin-bottom: 18px;
`;
const Statement = styled.p`
  margin: 0;
  font-family: ${theme.fontHeading};
  font-weight: 800;
  font-size: 32px;
  line-height: 1.25;
  text-transform: uppercase;
  letter-spacing: -0.01em;
`;
const Body = styled.p`
  margin: 0 0 24px 0;
  font-size: 15.5px;
  line-height: 1.8;
  color: ${theme.textMuted};
`;
const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
const Tag = styled.div`
  font-family: ${theme.fontMono};
  font-size: 12px;
  padding: 7px 13px;
  background: ${theme.card};
  color: ${theme.text};
  border: 1px solid ${theme.borderLight};
`;
const InterestsLabel = styled.div`
  font-family: ${theme.fontMono};
  font-size: 12px;
  letter-spacing: 0.06em;
  color: ${theme.textDim};
  text-transform: uppercase;
  margin: 26px 0 10px 0;
`;
const InterestsRow = styled.div`
  font-family: ${theme.fontHeading};
  font-size: 14px;
  color: ${theme.textMuted};
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;
const InterestSep = styled.span`
  color: ${theme.accent};
`;

const skills = [
  'React', 'Node.js', 'Express', 'MySQL', 'Redis', 'Docker', 'JavaScript',
  'HTML5', 'CSS / Sass', 'Git / GitHub', 'Linux', 'WebSockets', 'Arduino',
  'PHP', 'Nginx', 'WordPress', 'Bootstrap', 'npm', 'Mailchimp', 'Photoshop', 'SEO',
  'MUI', 'Formik', 'JWT', 'AWS', 'Axios', 'Sentry.io', 'Framer Motion',
];

const interests = [
  'Machine Vision', '3D Printing', 'CAD', 'DevOps', 'IoT', 'Hardware', 'Arduino', 'Dog Training',
];

export default function AboutMe() {
  return (
    <Section id="About">
      <Reveal>
        <Col>
          <Label>About</Label>
          <Statement>Full-stack, from schema to shipped UI &mdash; not just the part you can see.</Statement>
        </Col>
      </Reveal>
      <Reveal delay="0.15s">
        <Col>
          <Body>
            By day I build for clients through Full Stack (Pty) Ltd. On my own time I ship my
            own products end to end &mdash; CannaLog (a grow-journaling app), a marketing site
            for a local pool builder, home automation for my own grow room, and a voice
            assistant that runs entirely on my own machine.
          </Body>
          <Tags>
            {skills.map((s) => <Tag key={s}>{s.toUpperCase()}</Tag>)}
          </Tags>
          <InterestsLabel>Also into</InterestsLabel>
          <InterestsRow>
            {interests.map((it, i) => (
              <React.Fragment key={it}>
                <span>{it}</span>
                {i < interests.length - 1 && <InterestSep>&middot;</InterestSep>}
              </React.Fragment>
            ))}
          </InterestsRow>
        </Col>
      </Reveal>
    </Section>
  );
}
